module.exports = __webpack_public_path__ + "static/year2003-59dcc61eb9a14e4044def44201e85f1f.jpg";